import { TRACK_BUTTON_CLICK } from '../actions';

export const trackButtonClickSet = (buttonName, data) => ({
  type: TRACK_BUTTON_CLICK,
  meta: data || {
    analytics: true,
    trackClick: true,
    buttonName,
  },
});

/* eslint-disable import/prefer-default-export */
export const trackButtonClick = (buttonName, data) => (dispatch) =>
  dispatch(trackButtonClickSet(buttonName, data));
